import React from 'react';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import styles from './price-range.scss';

const PriceRange = props => {
    let errorFlag = false;
    let inputHtml = props.inputObj.map((cur,index) => {
        return (
            <InputWithMovingLabel 
                label={cur.label}
                holderClass={cur.holderClass}
                errClass = {cur.errorClass || cur.holderClass + '-error'}
                input={cur.input}
                key={index}
                as={cur.as}
                errorMessage={props.errors && props.errors[cur.key]}
                showArrow={cur.showArrow}
                disableMovingLabel={cur.disableMovingLabel}
                labelAlwaysUp={cur.labelAlwaysUp}
                prepend={cur.prepend}
				hidePrependBar={cur.hidePrependBar}
                className={cur.className}
                rightIconClass={cur.rightIconClass}
                onRightIconClick={cur.onRightIconClick}
                showPreTextWithoutFocus={cur.showPreTextWithoutFocus}
            />
        )
    })
    return (
        <div className={`${props.holderClass} ${styles['price-range']}`} style={{display: 'flex',alignItems:!props.doNotCenter ? 'center' : 'flex-start'}}>
            {inputHtml[0]}
            <span className={`${styles['range-text']} ${styles['dash']}`}>{!props.hideDash ? '-' : null}</span>
            {inputHtml[1]}
            {inputHtml[2] != undefined ? 
            <>
                <span className={styles['range-text']}>/</span>
                {inputHtml[2]}
            </> 
            : null}
            
        </div>
    );
}

export default PriceRange;